"use strict";
import { useCallback, useMemo } from "react";
import { useDisconnect as useDisconnectWagmi } from "wagmi";
import { logger } from "utilities/src/logger/logger";
export function useDisconnect() {
  const { connectors, disconnect, ...rest } = useDisconnectWagmi();
  const disconnectAll = useCallback(() => {
    connectors.forEach((connector) => {
      try {
        const result = disconnect({ connector });
        if (result instanceof Promise) {
          result.catch((error) => {
            if (error instanceof Error && error.message.includes("disconnect is not a function")) {
              logger.warn("useDisconnect", "disconnectAll", `Failed to disconnect ${connector.name}: ${error.message}`);
            } else {
              logger.error(error, {
                tags: { file: "useDisconnect.ts", function: "disconnectAll" },
                extra: { connectorName: connector.name }
              });
            }
          });
        }
      } catch (error) {
        if (error instanceof Error && error.message.includes("disconnect is not a function")) {
          logger.warn("useDisconnect", "disconnectAll", `Failed to disconnect ${connector.name}: ${error.message}`);
        } else {
          logger.error(error, {
            tags: { file: "useDisconnect.ts", function: "disconnectAll" },
            extra: { connectorName: connector.name }
          });
        }
      }
    });
  }, [connectors, disconnect]);
  return useMemo(() => ({ ...rest, disconnect: disconnectAll, connectors }), [disconnectAll, connectors, rest]);
}
